import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Input, Select } from 'semantic-ui-react'
import classnames from 'classnames/bind'
import { commonPropTypes, formFieldWrapper } from '../formFieldWrapper'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

class DropdownInputField extends Component {
  static propTypes = {
    fieldProps: PropTypes.object.isRequired,
    showError: PropTypes.bool,
    compact: PropTypes.bool,
  }

  static defaultProps = {
    compact: false,
  }

  state = {
    dropdownValue: '',
    inputValue: '',
  }

  constructor(props) {
    super(props)
    const vals = this.splitValue(props, this.state)
    if (vals) {
      this.state = vals
    }
  }

  splitValue = props => {
    const { fieldProps } = props
    const val = _.get(fieldProps, 'value')
    const splitValue = fieldProps.splitValue

    if (typeof val !== 'undefined' && splitValue) {
      const [dropdownValue, inputValue] = splitValue(val)
      return {
        dropdownValue: dropdownValue || fieldProps.dropdownDefault,
        inputValue: typeof inputValue === 'undefined' ? '' : inputValue,
      }
    }
    return null
  }

  constructValue = () => `${this.state.dropdownValue}${this.state.inputValue}`

  onChange = () => {
    const { onChange } = this.props.fieldProps
    onChange(this.constructValue())
  }

  onBlur = () => {
    const { onBlur } = this.props.fieldProps
    onBlur(this.constructValue())
  }

  onInputChange = e => {
    this.setState({ inputValue: e.target.value }, this.onChange)
  }

  onInputBlur = e => {
    this.setState({ inputValue: e.target.value }, this.onBlur)
  }

  onDropdownChange = (e, data) => {
    this.setState({ dropdownValue: data.value }, this.onChange)
  }

  // eslint-disable-next-line
  UNSAFE_componentWillReceiveProps = nextProps => {
    const { value: nextValue } = nextProps.fieldProps
    const { value: curValue } = this.props.fieldProps
    if (nextValue !== curValue) {
      const vals = this.splitValue(nextProps)
      if (vals) {
        this.setState(vals)
      }
    }
  }

  render() {
    const {
      disabled,
      elmId,
      label,
      placeholder,
      inputLabel,
      dropdownOptions,
      dropdownDefault, // eslint-disable-line
      splitValue, // eslint-disable-line
      compact,
      className,
      ...rest
    } = this.props.fieldProps
    const { showError } = this.props

    // overwrite the value to be used by true input (just inputValue part)
    const newInput = {
      onChange: this.onInputChange,
      onBlur: this.onInputBlur,
      value: this.state.inputValue,
    }
    const newClassName = classnames({
      compact,
      [className]: true,
    })

    return (
      <Input
        className={newClassName}
        error={showError}
        placeholder={placeholder || label}
        data-elm-id={`${elmId}_input`}
        label={inputLabel}
        actionPosition={dropdownOptions ? 'left' : undefined}
        disabled={!!disabled}
        {...rest}
        {...newInput}
      >
        {!!dropdownOptions && (
          <Select
            data-elm-id={`${elmId}_input_dropdown`}
            disabled={!!disabled}
            options={dropdownOptions}
            value={this.state.dropdownValue}
            onChange={this.onDropdownChange}
            className={`${cx('select')} ${compact ? 'compact' : ''}`}
          />
        )}
        <input />
      </Input>
    )
  }
}

const DropdownInputFieldWrapped = formFieldWrapper((fieldProps, showError) => {
  return <DropdownInputField fieldProps={fieldProps} showError={showError} />
})

DropdownInputFieldWrapped.propTypes = commonPropTypes

export default DropdownInputFieldWrapped
